exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body.sidebar-opened #trash{right:360px}#trash{display:none;height:100px;left:80px;right:0;position:fixed;background-color:transparent;top:0;z-index:5000}#trash:not(.no-grab){cursor:grabbing}#trash #trash-icon{width:32px;height:32px;top:20px;left:50%;position:absolute;background-color:transparent;box-sizing:border-box;z-index:95}@media screen and (min--moz-device-pixel-ratio:0){#trash #trash-icon{width:32px;height:32px;transform:scale(1.06)}}", ""]);

// exports
